export default "__VITE_ASSET__B5tltp1z__"